import { render, staticRenderFns } from "./account-unbind.vue?vue&type=template&id=6f2b0b33&scoped=true&"
import script from "./account-unbind.vue?vue&type=script&lang=js&"
export * from "./account-unbind.vue?vue&type=script&lang=js&"
import style0 from "./account-unbind.vue?vue&type=style&index=0&id=6f2b0b33&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b0b33",
  null
  
)

export default component.exports